import { Component, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';

import { ToastService } from '@shared/components/toast/toast.service';
import { FeedbackSubmitService } from '@shared/data-access/feedback/feedback-submit.service';

@Component({
  selector: 'app-feedback-modal',
  imports: [ReactiveFormsModule],
  templateUrl: './feedback-modal.component.html',
  styleUrl: './feedback-modal.component.scss',
})
export class FeedbackModalComponent {
  readonly activeModal = inject(NgbActiveModal);
  readonly formBuilder = inject(FormBuilder);
  form: FormGroup;

  showSuppressOption: boolean = false;
  dontShowAgain: boolean = false;

  protected stage: number = 0;

  private readonly feedbackSubmitService = inject(FeedbackSubmitService);
  private readonly toastService = inject(ToastService);

  constructor() {
    this.form = this.formBuilder.group({
      mood: '',
      feedback: '',
    });
  }

  selectMood(value: string) {
    this.form.get('mood')?.setValue(value);
  }

  submit() {
    this.feedbackSubmitService.submitFeedback(this.form.value);
    this.showSuccess(
      'Vielen Dank für Ihr Feedback!😊 Durch Ihre Rückmeldung helfen Sie uns Phishlab weiter für Sie zu verbessern!'
    );

    this.stage = 1;
  }

  showSuccess(message: string) {
    this.toastService.showSuccess(message);
  }
}
